import React from "react"
import PropTypes from "prop-types"

const ErrorIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <path d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 16.4c-.7 0-1.2-.5-1.2-1.2S9.3 14 10 14s1.2.5 1.2 1.2c0 .6-.5 1.2-1.2 1.2zm0-3.6c-.9 0-1.6-6.7-1.6-7.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.7 7.6-1.6 7.6z" />
  </svg>
)

ErrorIcon.propTypes = {
  style: PropTypes.object
}

export default ErrorIcon



// WEBPACK FOOTER //
// ./src/components/icons/error-icon.jsx